import {until} from 'lit-html/directives/until';
import {repeat} from 'lit-html/directives/repeat';

export default (ctx, html) => html`
  <table aria-label="${ctx['aria-label']}" class="table ${ctx['disable-selection'] ? '' : 'table-hover'}">
    <thead class="thead-light">
      <tr>
        ${!ctx['disable-selection'] ? html`
        <th scope="col" class="select-col outline-focus-red">
          <ems-dropdown>
            <div slot="dropdown-toggle" @click="${ctx.toggleSelectMenu}">
              <div class="custom-control custom-checkbox">
                <input id="check-all" type="checkbox" class="custom-control-input d-none" ?checked="${ctx['select-all']}">
                <label class="custom-control-label" for="check-all"></label>
              </div>
            </div>
            <div slot="dropdown-menu" class="dropdown-menu dropdown-menu-right m-0 w-100" style="right: 0; left: auto;">
              <div tabindex="0" class="btn dropdown-item ${ctx.selectionMode === 'all' ? 'active' : ''}" @keypress="${(e) => (e.key === 'Enter') ? ctx.toggleAll(e, 'all'): null}" @click="${(e) => ctx.toggleAll(e, 'all')}">${until(ctx.__('<tt-RV+O4MYs>', 'Select All'))}</div>
              <div tabindex="0" class="btn dropdown-item ${ctx.selectionMode === 'page' ? 'active' : ''}" @keypress="${(e) => (e.key === 'Enter') ? ctx.togglePage(e, 'page', ctx): null}" @click="${(e) => ctx.togglePage(e, 'page', ctx)}">${until(ctx.__('<tt-dFYWx9CY>', 'Select Page'))}</div>
            </div>
          </ems-dropdown>
        </th>` : ''}
        ${ctx.config.map((item, index) => item.disabled ? '' : html`
        <th scope="col" tabindex="0" class="text-nowrap ${item.sortable? `sort ${item.order}`: ''} ${item.headClassList}">
          ${item.sortable ? html`<a data-bi-id="${ctx['aria-label']}-table-header-${item.key}" @click="${(e) => ctx.sortBy(e, index, item)}" @keypress="${(e) => (e.key === 'Enter') ? ctx.sortBy(e, index, item): null}">${until(item.label)}</a>` : until(item.label)}
        </th>
        `)}
      </tr>
    </thead>
    <tbody>
      ${repeat(ctx.results, (res) => res.id, (result, index) => html`

      <tr @keypress="${(e) => (e.code === 'Enter' || e.code === 'Space') ? ctx.rowClicked(e, index, result): null}" @click="${(e) => ctx.rowClicked(e, index, result)}" class="${ctx['row-classlist']} outline-focus-red">
        ${!ctx['disable-selection'] ? html`<td @click="${(e) => e.stopPropagation()}" class="cursor-default">
          <div class="custom-control custom-checkbox">
            <input id="check-${result.id}" type="checkbox" class="custom-control-input" .checked="${result.$selected}" @change="${(e) => ctx.rowToggle(e, index, result)}">
            <label class="custom-control-label" for="check-${result.id}"></label>
          </div>
        </td>` : ''}
        ${ctx.config.map((item) => item.disabled ? '' : html`<td class="${item.classList}">${
          typeof item.render === 'function' ? item.render(html, result, index) : result[item.key]}</td>`)}
      </tr>
      `)}
    </tbody>
  </table>
`;
